`use strict`;

class Draad_Sliders {

	constructor( slider, sliderIndex ) {
		this.section = slider;
		this.sliderSelector = getComputedStyle( slider ).getPropertyValue( '--slider-element' ) || '.slider';
		this.slider = slider.querySelector( this.sliderSelector ) || false;

		if ( !this.slider ) {
			console.log( 'No slider element found for the following elemnt:', slider );
			return;
		}

		this.sliderIndex = sliderIndex;
		this.sliderClass = this.slider.classList[0];

		// get the body font size, so we can use this to use rem inside the (s)css files 
		this.bodyFontSize = parseFloat( getComputedStyle( document.body ).fontSize ) || 16;

		// get computedStyle of this.slider for the settings of this slider
		this.sectionComputed = getComputedStyle( this.slider );

		//slider conditional option
		this.sliderActive = this.sectionComputed.getPropertyValue( '--slider-active' ) || 'show';

		// find slider controls
		this.sliderControlsSelector = this.sectionComputed.getPropertyValue( '--slider-controls-element' ) || '.slider__controls';
		this.sliderControls = this.section.querySelector( this.sliderControlsSelector );

		if ( this.sliderActive !== 'show' ) {
			if ( this.sliderControls ) {
				this.sliderControls.setAttribute( 'hidden', 'hidden' );
			}

			return;
		}

		// slider methods
		this.generalSliderProperties();
		this.generalQuerySelectors();

		this.slider.classList.add( 'swiper' );
		this.slidesSelector.classList.add( 'swiper-wrapper' );
		this.itemsSelector.forEach( function ( slide ) {
			slide.classList.add( 'swiper-slide' );
			slide.classList.add( 'slider__slide' );
		});

		this.prepareSlider();
		this.initializeSlider();

		//resize event
		window.addEventListener( 'resize', this.onResizeChanges.bind( this ) );
	}

	initializeSlider() {    
		this.swiper = new Swiper( this.slider, {
			autoHeight: this.sliderAutoHeight(),
			autoplay: this.sliderAutoPlay(),
			effect: this.sliderEffect(),
			cardsEffect: this.sliderEffectCards(),
			coverflowEffect: this.sliderEffectCoverflow(),
			fadeEffect: this.sliderEffectFade(),
			grid: this.sliderGrid(),
			hashNavigation: this.sliderHashNavigation(),
			keyboard: true,
			loop: this.sliderLoop(),
			navigation: this.sliderNavigation(),
			on: this.sliderOnChange(),
			pagination: this.sliderPagination(),
			spaceBetween: this.sliderSpaceBetween(),
			slidesPerView: this.sliderSlides(),
			slidesPerGroup: this.sliderSlidesPerGroup(),
			speed: this.sliderSpeed(),
		});
	}

	generalSliderProperties() {
		this.autoHeight = this.sectionComputed.getPropertyValue( '--autoheight' ) || false;
		this.autoPlay = this.sectionComputed.getPropertyValue( '--autoplay' ) || false;
		this.effect = this.sectionComputed.getPropertyValue( '--effect' ) || 'slide';
		this.grid = this.sectionComputed.getPropertyValue( '--grid' ) || false;
		this.hashNavigation = this.sectionComputed.getPropertyValue( '--hash-navigation' ) || false;
		this.loop = this.sectionComputed.getPropertyValue( '--loop' ) || false;
		this.pagination = this.sectionComputed.getPropertyValue( '--pagination' ) || 'show';
		this.paginationType = this.sectionComputed.getPropertyValue( '--pagination-type' ) || 'progressbar';
		this.navigation = this.sectionComputed.getPropertyValue( '--navigation' ) || 'show';
		this.numbers = this.sectionComputed.getPropertyValue( '--numbers' ) || 'show';
	}

	generalQuerySelectors() {
		if ( this.sliderControls ) {
			this.sliderPagerSelector = this.sectionComputed.getPropertyValue( '--slider-pager-element' ) || '.slider__pager';
			this.pagerSelector = this.section.querySelector( this.sliderPagerSelector ) || false;

			this.sliderNextSelector = this.sectionComputed.getPropertyValue( '--slider-next-element' ) || '.slider__next';
			this.nextSelector = this.section.querySelector( this.sliderNextSelector ) || false;

			this.sliderPrevSelector = this.sectionComputed.getPropertyValue( '--slider-prev-element' ) || '.slider__prev';
			this.prevSelector = this.section.querySelector( this.sliderPrevSelector ) || false;

			this.sliderCurrentSelector = this.sectionComputed.getPropertyValue( '--slider-current-element' ) || '.slider__current';
			this.currentSelector = this.section.querySelector( this.sliderCurrentSelector ) || false;

			this.sliderTotalSelector = this.sectionComputed.getPropertyValue( '--slider-total-element' ) || '.slider__total';
			this.totalSelector = this.section.querySelector( this.sliderTotalSelector ) || false;
		}
		
		this.sliderSlidesSelector = this.sectionComputed.getPropertyValue( '--slider-slides-element' ) || '.slider__slides';
		this.slidesSelector = this.section.querySelector( this.sliderSlidesSelector ) || false;

		this.itemsSelector = Array.from( this.slidesSelector.children );
	}

	prepareSlider() {
		const hashNavigation = this.hashNavigation;
		const sliderIndex = this.sliderIndex;
		if ( hashNavigation === 'show' ) {
			this.itemsSelector.forEach( function ( slide, index ) {
				slide.setAttribute( 'data-hash', `slide${index + '-slider' + sliderIndex}` );
				index++;
			});
		}

		function toggleAttributes( element, attributeValue ) {
			if ( attributeValue === 'show' ) {
				element.hasAttribute( 'aria-hidden' ) ? element.setAttribute( 'aria-hidden', 'false' ) : '';
				element.removeAttribute( 'hidden' );
			} else {
				element.setAttribute( 'aria-hidden', 'true' );
				element.setAttribute( 'hidden', 'hidden' );
			}
		}
		
		if ( this.sliderControls ) {

			// Pagination
			if ( this.pagerSelector ) {
				this.pagerSelector.classList.toggle( 'swiper-pagination', this.pagination === 'show' ) || '';
				toggleAttributes( this.pagerSelector, this.pagination );
			}

		
			// Navigation
			if ( this.nextSelector ) {
				toggleAttributes( this.nextSelector, this.navigation );
			}

			if ( this.prevSelector ) {
				toggleAttributes( this.prevSelector, this.navigation );
			}
		
			// Numbers
			if ( this.currentSelector ) {
				toggleAttributes( this.currentSelector, this.numbers );
			}

			if ( this.totalSelector ) {
				toggleAttributes( this.totalSelector, this.numbers );
			}

		}			
	}

	sliderAutoHeight() {
		if ( this.autoHeight !== 'show' ) {
			return false;
		}
		
		return true;
	}

	sliderAutoPlay( autoPlay = {} ) {
		if ( this.autoPlay !== 'show' ) {
			return false;
		}

		this.autoPlayDelay = this.sectionComputed.getPropertyValue( '--autoplay-delay' ) || 3000;

		autoPlay = {
			delay: this.autoPlayDelay,
		};

		return autoPlay;
	}

	// start of slider effects
	sliderEffect() {
		return this.effect;
	}

	sliderEffectCards( cardsEffect = {} ) {
		if ( this.effect !== 'cards' ) {
			return false;
		}

		this.cardsEffectPerSlideOffset = this.sectionComputed.getPropertyValue( '--cards-per-slide-offset' ) || 20;

		this.cardsEffectPerSlideRotate = this.sectionComputed.getPropertyValue( '--cards-per-slide-rotate' ) || 2;

		this.cardsEffectRotate = this.sectionComputed.getPropertyValue( '--cards-rotate' ) || 'show';
		this.cardsEffectRotate = ( this.cardsEffectRotate === 'show' ) ? true : false;

		this.cardsEffectSlideShadows = this.sectionComputed.getPropertyValue( '--cards-slide-shadows' ) || 'show';
		this.cardsEffectSlideShadows = ( this.cardsEffectSlideShadows === 'show' ) ? true : false;

		cardsEffect = {
			perSlideOffset: this.cardsEffectPerSlideOffset,
			perSlideRotate: this.cardsEffectPerSlideRotate,
			rotate: this.cardsEffectRotate,
			slideShadows: this.cardsEffectSlideShadows,
		};

		return cardsEffect;
	}

	sliderEffectCoverflow( coverflowEffect = {} ) {
		if ( this.effect !== 'coverflow' ) {
			return false;
		}

		this.coverflowEffectDepth = this.sectionComputed.getPropertyValue( '--coverflow-depth' ) || 100;
		this.coverflowEffectModifier = this.sectionComputed.getPropertyValue( '--coverflow-modifier' ) || 1;
		this.coverflowEffectRotate = this.sectionComputed.getPropertyValue( '--coverflow-rotate' ) || 50;
		this.coverflowEffectScale = this.sectionComputed.getPropertyValue( '--coverflow-scale' ) || 1;
		this.coverflowEffectSlideShadows = this.sectionComputed.getPropertyValue( '--coverflow-slide-shadows' ) || 'show';
		this.coverflowEffectSlideShadows = ( this.coverflowEffectSlideShadows === 'show' ) ? true : false;
		this.coverflowEffectStretch = this.sectionComputed.getPropertyValue( '--coverflow-stretch' ) || 0;

		coverflowEffect = {
			depth: this.coverflowEffectDepth,
			modifier: this.coverflowEffectModifier,
			rotate: this.coverflowEffectRotate,
			scale: this.coverflowEffectScale,
			slideShadows: this.coverflowEffectSlideShadows,
			stretch: this.coverflowEffectStretch,
		};

		return coverflowEffect;
	}

	sliderEffectFade( fadeEffect = {} ) {
		if ( this.effect !== 'fade' ) {
			return false;
		}

		this.fadeEffectCrossFade = this.sectionComputed.getPropertyValue( '--fade-crossfade' ) || 'show';
		this.fadeEffectCrossFade = ( this.fadeEffectCrossFade === 'show' ) ? true : false;

		fadeEffect = {
			crossFade: this.fadeEffectCrossFade,
		};

		return fadeEffect;
	}
	// end of slider effects

	sliderGrid( rows = {} ) {
		if ( this.grid !== 'show' ) {
			return false;
		}

		this.gridRows = this.sectionComputed.getPropertyValue( '--grid-rows' ) || 1;

		rows = {
			fill: 'row',
			rows: this.gridRows,
		};

		return rows;
	}

	sliderHashNavigation( ) {
		if ( this.hashNavigation !== 'show' ) {
			return false;
		}

		return true;
	}

	sliderLoop() {
		if ( this.loop !== 'show' ) {
			return false;
		}

		return true;
	}

	sliderNavigation( navigation = {} ) {
		if ( this.navigation !== 'show' ) {

			if ( this.sliderControls ) {
				this.sliderControls.setAttribute( 'hidden', 'hidden' );
			}

			return false;
		}

		navigation = {
			nextEl: this.nextSelector,
			prevEl: this.prevSelector,
		};

		return navigation;
	}

	sliderOnChange( on = {} ) {
		if ( this.numbers !== 'show' || !this.sliderControls ) {
			return false;
		}

		const currentSelector = this.currentSelector;

		on = {
			slideChange: function () {
				currentSelector.innerHTML = ( this.realIndex < 9 ) ? '0' + ( this.realIndex + 1 ) : this.realIndex + 1;
			},
		};

		return on;
	}

	sliderPagination( pagination = {} ) {
		if ( this.pagination !== 'show' || !this.sliderControls ) {
			return false;
		}

		pagination = {
			el: this.pagerSelector,
			type: this.paginationType,
		};

		if ( this.paginationType !== 'bullets' ) {
			return pagination;
		}

		pagination.clickable = true;

		this.sliderBulletsSelector = this.sectionComputed.getPropertyValue( '--slider-bullets-element' ) || '.slider__bullets';
		let bullets = this.slider.querySelector( this.sliderBulletsSelector ) || false;
		if ( this.paginationType === 'bullets' && bullets ) {
			bullets = bullets.children;

			pagination.renderBullet = function ( index, className ) {
				return '<span class="' + className + '">' + bullets[index].innerHTML + '</span>';
			}
		}

		this.dynamicBullets = this.sectionComputed.getPropertyValue( '--pagination-dynamic-bullets' ) || false;
		this.dynamicBulletsVisible = this.sectionComputed.getPropertyValue( '--pagination-dynamic-bullets-visible' ) || 3;
		this.dynamicBulletsVisible = parseInt( this.dynamicBulletsVisible );

		if ( this.dynamicBullets !== 'show' || this.dynamicBulletsVisible <= 0 ) {
			return pagination;
		}

		pagination.dynamicBullets = true;
		pagination.dynamicMainBullets = this.dynamicBulletsVisible;

		return pagination;
	}

	sliderSpaceBetween() {
		this.spaceBetween = this.sectionComputed.getPropertyValue( '--space-between' ) || 0;
		if ( this.bodyFontSize ) {
			this.spaceBetween = parseFloat( this.spaceBetween ) * this.bodyFontSize;	
		}
		return this.spaceBetween;
	}

	sliderSpeed() {
		this.speed = this.sectionComputed.getPropertyValue( '--speed' ) || 300;

		return this.speed;
	}

	sliderSlides() {
		this.slides = this.sectionComputed.getPropertyValue( '--slides' ) || 1;

		return this.slides;
	}

	sliderSlidesPerGroup() {
		this.slidesPerGroup = this.sectionComputed.getPropertyValue( '--slides-per-group' ) || 1;

		return this.slidesPerGroup;
	}

	onResizeChanges() {
		this.generalSliderProperties();

		this.swiper.params.autoHeight = this.sliderAutoHeight();
		this.swiper.params.autoplay = this.sliderAutoPlay();
		this.swiper.params.effect = this.sliderEffect();
		this.swiper.params.cardsEffect = this.sliderEffectCards();
		this.swiper.params.coverflowEffect = this.sliderEffectCoverflow();
		this.swiper.params.fadeEffect = this.sliderEffectFade();
		this.swiper.params.grid = this.sliderGrid();
		this.swiper.params.hashNavigation = this.sliderHashNavigation();
		this.swiper.params.loop = this.sliderLoop();
		this.swiper.params.navigation = this.sliderNavigation();
		this.swiper.params.on = this.sliderOnChange();
		this.pagination = this.sliderPagination();
		this.swiper.params.pagination = this.sliderPagination();
		this.pagination = this.swiper.params.pagination;
		this.swiper.params.spaceBetween = this.sliderSpaceBetween();
		this.swiper.params.slidesPerView = this.sliderSlides();
		this.swiper.params.slidesPerGroup = this.sliderSlidesPerGroup();
		this.swiper.params.speed = this.sliderSpeed();

		this.prepareSlider();
	}
}

document.addEventListener( "DOMContentLoaded", () => {
	
	const draadSliders = [];

	// const draadSlidersNodes = document.querySelectorAll('.slider');
	const draadSlidersNodes = getComputedStyle( document.body ).getPropertyValue( '--sliders-active' ) || document.querySelectorAll( 'section:has(.slider), header:has(.slider), dialog:has(.slider)' );
	let sliderIndex = 0;

	draadSlidersNodes.forEach( function( slider ) {

		draadSliders.push( new Draad_Sliders( slider, sliderIndex++ ) );

	});

} );